export default function SimplePastTense() {
  return (
    <table className="table_sticky">
      <tbody>
        <tr>
          <th>
            <em>infinitive</em>
          </th>
          <td> dělati </td>
          <td> nesti </td>
          <td> hvaliti </td>
        </tr>
        <tr>
          <th>
            <em>infinitive stem</em>
          </th>
          <td>
            <b>děla-</b>
          </td>
          <td>
            <b>nes-</b>
          </td>
          <td>

            <b>hvali-</b>
          </td>
        </tr>
        <tr>
          <th> ja </th>
          <td> dělah </td>
          <td> neseh </td>
          <td> hvalih </td>
        </tr>
        <tr>
          <th> ty </th>
          <td> dělaše </td>
          <td> neseše </td>
          <td> hvališe </td>
        </tr>
        <tr>
          <th> on/ona/ono </th>
          <td> dělaše </td>
          <td> neseše </td>
          <td> hvališe </td>
        </tr>
        <tr>
          <th> my </th>
          <td> dělahmo </td>
          <td> nesehmo </td>
          <td> hvalihmo </td>
        </tr>
        <tr>
          <th> vy </th>
          <td> dělaste </td>
          <td> neseste </td>
          <td> hvaliste </td>
        </tr>
        <tr>
          <th> oni/one </th>
          <td> dělahu </td>
          <td> nesehu </td>
          <td> hvalihu </td>
        </tr>
      </tbody>
    </table>
  )
}
